/**
 * useLoadApp
 */

import { useCallback } from 'react';
import {
    useAdobeTarget,
    useIsEU,
    useReelStore,
} from 'bdvp-common/src/hooks/store';
import { useMediaConfig } from 'bdvp-common/src/hooks/config';

const useLoadApp = () => {

    const { loadIsEU } = useIsEU();
    const { adobeTarget: adobeTargetConfig = {} } = useMediaConfig();
    const { loadTargetOffer } = useAdobeTarget(adobeTargetConfig);
    const { bootstrapReel } = useReelStore();

    const loadApp = useCallback(() => {

        loadIsEU();
        loadTargetOffer();
        bootstrapReel();

    }, [
        loadIsEU,
        loadTargetOffer,
        bootstrapReel,
    ]);

    return {
        loadApp,
    };

};

export default useLoadApp;
